import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Link } from '@codex/basics';
import { Device, DeviceProvider } from '@codex/gadgets';
import { EnvironmentThemeProvider } from '@codex/themes';
import CompareProduct from './presentionalComponents/CompareProduct';
import CompareAddItemButton from './presentionalComponents/CompareAddItemButton';
import { convertProductToAjaxAPIProductFormat } from './helpers';

const MAX_NUMBER = 4;

const CompareButton = styled(Button)`
  display: flex;
  align-items: center;
  height: 40px;
  width: auto;
  padding: 0 20px;
  font-size: 14px;
  color: #4855a0;
  border: 2px solid #4855a0;
  border-radius: 3px;
  margin: 0 20px;
  outline: 0;
  transition: background .2s ease;
  white-space: nowrap;
  @media only screen and (max-width: 1024px) {
    margin: 0 10px;
  };
`;

const ClearAllWrapper = styled.div`
  display: flex;
  @media only screen and (max-width: 1260px) {
    margin-right: 15px;
  };
`;

const ClearAll = styled(Link)`
  text-align: center;
  width: 55px;
`;

class ComparePanel extends PureComponent {
  constructor(props) {
    super(props);

    this.productToRemove = this.productToRemove.bind(this);
    this.removeAllProducts = this.removeAllProducts.bind(this);
    this.addProduct = this.addProduct.bind(this);
  }

  productToRemove(product) {
    this.props.onRemoveProduct(product);
  }

  removeAllProducts() {
    const l = this.props.products.length;
    for (let i = 0; i < l; i++) {
      this.productToRemove(this.props.products[i]);
    }
  }

  addProduct(e, product) {
    e.preventDefault();
    this.props.onAddProduct(product);
  }

  render() {
    const compareItems = [];
    const { props } = this;
    const productOnPDP = window.digitalData.product
      ? window.digitalData.product[0].productID : null;
    const convertedProduct = productOnPDP
      ? convertProductToAjaxAPIProductFormat(window.digitalData.product[0]) : null;
    let alreadyInCompare = false;

    // check for back to top button on touch devices
    const backToTop = document.getElementById('backTop') || null;
    if (backToTop) {
      if (props.products.length === 0) {
        backToTop.classList.remove('withCompare');
      } else {
        backToTop.classList.add('withCompare');
      }
    }

    for (let i = 0; i < MAX_NUMBER; i++) {

      const product = props.products[i] || null;
      const isFirst = !!(i === 0);

      if (product && product.id && productOnPDP === product.id) {
        alreadyInCompare = true;
      }

      compareItems.push(
        <div
          className={product
            ? 'dc-compare-panel-item'
            : 'dc-compare-panel-item dc-compare-panel-item-empty'}
          key={i}
        >
          {product ? (

            <CompareProduct
              title={product.title}
              prices={product.price}
              url={product.link}
              brand={product.brand.title}
              imageSrc={product.image.src}
              imageAlt={product.image.label}
              isOutOfStock={product.isOutOfStock}
              onRemove={() => this.productToRemove(product)}
              translations={props.translations}
              firstChild={isFirst}
              onTooltipClick={props.onPopupDisplay}
            />
          ) : (!alreadyInCompare && productOnPDP && (
            <CompareAddItemButton
              label={this.props.translations.addThisItem}
              onAddItem={(e) => this.addProduct(e, convertedProduct)}
            />
          )
          )}
        </div>
      );
    }

    return (
      <EnvironmentThemeProvider>
        <div>
          {props.products.length > 0 && (
            <div className={'dc-compare-panel'}>

              { compareItems }

              <DeviceProvider>
                <Device>
                  {({ isDesktop }) => (
                    <CompareButton onClick={props.buttonClick}>
                      {this.props.translations.compareLabel}
                      {isDesktop ? ' products' : ''}
                      {' '}
                      (
                      {props.products.length}
                      {' '}
                      of 4)
                    </CompareButton>
                  )}
                </Device>
              </DeviceProvider>

              <ClearAllWrapper>
                <ClearAll onClick={() => this.removeAllProducts()}>
                  {this.props.translations.clearAll}
                </ClearAll>
              </ClearAllWrapper>

            </div>
          )}
        </div>
      </EnvironmentThemeProvider>
    );
  }
}

ComparePanel.displayName = 'ComparePanel';

ComparePanel.propTypes = {
  buttonClick: PropTypes.func,
  products: PropTypes.arrayOf(PropTypes.object),
  onAddProduct: PropTypes.func,
  onRemoveProduct: PropTypes.func,
  onPopupDisplay: PropTypes.func,
  translations: PropTypes.objectOf(PropTypes.string).isRequired
};

ComparePanel.defaultProps = {
  buttonClick: () => {},
  products: [],
  onAddProduct: () => {},
  onRemoveProduct: () => {},
  onPopupDisplay: () => {}
};

export default ComparePanel;
